import {Component, inject, Signal} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {Filepath} from "../types/filepath.type";


export type ImageDialogData = {
    imageFile: Filepath;
    title: Signal<string>;
}

@Component({
  selector: 'app-image-dialog',
  imports: [],
  templateUrl: './image-dialog.component.html',
  styleUrl: './image-dialog.component.scss'
})
export class ImageDialogComponent {
  readonly data: ImageDialogData = inject(MAT_DIALOG_DATA);
}
